import type { ReactNode } from "react";
import { T } from "./tokens";

interface ScoreChipProps {
  icon?: ReactNode;
  value: string | number;
  label: string;
  accent?: boolean;
}

export function ScoreChip({ icon, value, label, accent = false }: ScoreChipProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 2,
        padding: "8px 0",
        minWidth: 56,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        {icon}
        <span
          style={{
            fontFamily: T.serif,
            fontSize: 26,
            fontWeight: 700,
            lineHeight: 1,
            color: accent ? T.goldGlow : T.cream,
          }}
        >
          {value}
        </span>
      </div>
      <span
        style={{
          fontFamily: T.sans,
          fontSize: 10.5,
          fontWeight: 500,
          letterSpacing: "0.08em",
          color: T.mist,
        }}
      >
        {label}
      </span>
    </div>
  );
}
